import { render, staticRenderFns } from "./_adapter.vue?vue&type=template&id=b5babd38"
import script from "./_adapter.vue?vue&type=script&lang=js"
export * from "./_adapter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports